module.exports = __webpack_public_path__ + "static/media/in_a_week_3.dbac0fe1.jpg";